export default {
  message_area_edited_label: 'edited',
};
